var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiologiaDeselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163.44 233.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eb4548;\n      }\n\n      .cls-2 {\n        fill: #f6e38a;\n      }\n\n      .cls-3 {\n        fill: #8486c0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raccolta"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.96,206.77c-11.49-48.42-75.49-83.98-95.93-118.43-12.44-20.98-23.15-56.6-21.58-82.6-1.81-.24-3.61-.48-5.41-.72C29.32,3.74,19.61,2.25,10.02.23c-2.87,24.44,6.55,49.06,20.42,69.44,14.11,20.72,32.64,37.96,50,56.04,17.37,18.08,34.01,37.66,43.06,61.05,5.43,14.04,7.96,29.19,7.39,44.22l31.72,2.44c.91-9.37,1.53-17.5-.65-26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.15,199.66c3.14,4.61,4.67,10.56,4.16,15.65-.04.43-.11.86-.2,1.29l59.82-.31c.63-6.04,1.21-12.02,2.34-17.84l-66.12,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.35,197.32l-62.08,1.13c-1.13,5.81-1.71,11.8-2.34,17.84l64.46-.33-.05-18.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.79,165.68c-3.72,5.2-7.42,10.42-11.09,15.66l54.62-.34c.91-5.4,1.79-10.64,2.54-15.92l-46.07.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.48,164.49l-45.62.59c-.76,5.28-1.64,10.52-2.54,15.92l48.21-.3-.04-16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.33,136.13l-12.16,11.38,28.43-.4c.48-3.62.85-7.31,1.32-10.98h-17.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.15,136.13h-22.24c-.47,3.67-.84,7.36-1.32,10.98l23.83-.33-.28-10.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.74,19.65l-53.4.19c-1.15,5.9-2.25,11.79-3.28,17.69l56.32-.73c.1-3.45.19-6.9.27-10.36.03-1.55.06-3.1.09-4.65,0,.32,0-.81,0-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.54,20.02v18.13l48.52-.63c1.02-5.9,2.12-11.79,3.28-17.69l-51.8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.04,55.24v15.98l38.48-.36c.36-5.27,1.53-10.53,2.75-15.8l-41.23.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.77,54.9l-35.51.16c-1.23,5.27-2.4,10.53-2.75,15.8l38.26-.36v-15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.23,87.94v11.57l20.82-.38c.41-3.74.86-7.58,1.39-11.4l-22.21.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.24,87.5l-22.8.23c-.53,3.83-.98,7.67-1.39,11.4l21.67-.4c.73-3.77,1.58-7.51,2.53-11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.06,7.23c1.09,25.86-9.45,60.53-21.66,81.12C76.97,122.79,12.96,158.35,1.48,206.77c-2.17,9.16-1.55,17.29-.65,26.66l31.72-2.44c-.57-15.04,1.96-30.19,7.39-44.22,9.04-23.38,25.69-42.97,43.06-61.05,17.37-18.08,35.9-35.32,50-56.04,13.92-20.45,23.35-45.16,20.39-69.68-11.41,2.56-22.85,4.96-34.33,7.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiologiaDeselected);
export default __webpack_public_path__ + "static/media/biologiaDeselected.b70c1e7500bd286e730685256245f16b.svg";
export { ForwardRef as ReactComponent };